'use client';

import * as Styled from './LoadingSpinner.module';

export const LoadingSpinner = () => {
  return <Styled.Spinner />;
};
